import { PRIVATE_ROUTES } from "../constants";
import { NavBarLink } from "../models/nav.bar.link";

export const links: { [x: string]: { [x: string]: Array<NavBarLink> } } = {
  SP: {
    network: [
      {
        menuTitle: "network",
        key: "network",
        path: PRIVATE_ROUTES.NETWORK,
        show: false,
      },
    ],
    dashboard: [
      {
        menuTitle: "dashboard",
        key: "overview",
        path: PRIVATE_ROUTES.OVERVIEW,
      },
    ],
    business: [
      {
        menuTitle: "products",
        key: "products",
        path: PRIVATE_ROUTES.PRODUCTS,
      },
    ],
    operations: [
      {
        menuTitle: "orders",
        key: "orders",
        path: PRIVATE_ROUTES.ORDERS,
      },
      {
        menuTitle: "Bookings",
        key: "bookings",
        path: PRIVATE_ROUTES.BOOKINGS,
      },
    ],
    invoices: [
      {
        menuTitle: "invoices",
        key: "invoices",
        path: PRIVATE_ROUTES.INVOICES,
      },
    ],
    reports: [
      {
        menuTitle: "reports",
        key: "analytics",
        path: PRIVATE_ROUTES.ANALYTICS,
        resource: "analytics",
      },
    ],
    settings: [
      {
        menuTitle: "settings",
        key: "settings",
        path: PRIVATE_ROUTES.SETTINGS,
      },
    ],
  },
  FM: {
    network: [
      {
        menuTitle: "network",
        key: "network",
        path: PRIVATE_ROUTES.NETWORK,
        show: false,
      },
    ],
    dashboard: [
      {
        menuTitle: "dashboard",
        key: "overview",
        path: PRIVATE_ROUTES.OVERVIEW,
      },
    ],
    business: [
      {
        menuTitle: "products",
        key: "products",
        path: PRIVATE_ROUTES.PRODUCTS,
      },
    ],
    operations: [
      {
        menuTitle: "orders",
        key: "orders",
        path: PRIVATE_ROUTES.ORDERS,
      },
      {
        menuTitle: "Bookings",
        key: "bookings",
        path: PRIVATE_ROUTES.BOOKINGS,
      },
      {
        menuTitle: "shipments",
        key: "shipments",
        path: PRIVATE_ROUTES.SHIPMENTS,
      },
      {
        menuTitle: "despatches",
        key: "despatches",
        path: PRIVATE_ROUTES.DESPATCHES,
      },
      {
        menuTitle: "routePlanner",
        key: "routePlanner",
        path: PRIVATE_ROUTES.ROUTE_PLANNER,
        resource: "route planner",
      },
    ],
    containers: [
      {
        menuTitle: "containers",
        key: "containers",
        path: PRIVATE_ROUTES.CONTAINERS,
      },
    ],
    reports: [
      {
        menuTitle: "reports",
        key: "analytics",
        path: PRIVATE_ROUTES.ANALYTICS,
        resource: "analytics",
      },
    ],
    suppliers: [
      {
        menuTitle: "suppliers",
        key: "suppliers",
        path: PRIVATE_ROUTES.SUPPLIERS,
      },
    ],
    settings: [
      {
        menuTitle: "settings",
        key: "settings",
        path: PRIVATE_ROUTES.SETTINGS,
      },
    ],
  },
  MV: {
    network: [
      {
        menuTitle: "network",
        key: "network",
        path: PRIVATE_ROUTES.NETWORK,
        show: false,
      },
    ],
    dashboard: [
      {
        menuTitle: "dashboard",
        key: "overview",
        path: PRIVATE_ROUTES.OVERVIEW,
      },
    ],
    sales: [
      {
        menuTitle: "leads",
        key: "leads",
        path: PRIVATE_ROUTES.LEADS,
      },
      {
        menuTitle: "quotes",
        key: "quote",
        path: PRIVATE_ROUTES.QUOTES,
      },
      {
        menuTitle: "proposal",
        key: "proposal",
        path: PRIVATE_ROUTES.PROPOSAL,
      },
      {
        menuTitle: "contacts",
        key: "customers",
        path: PRIVATE_ROUTES.CUSTOMERS,
      },
      {
        menuTitle: "contacts",
        key: "suppliers",
        path: PRIVATE_ROUTES.SUPPLIERS,
      },
      {
        menuTitle: "contacts",
        key: "subcontractors-mnt",
        path: PRIVATE_ROUTES.SETTINGS,
      },
      {
        menuTitle: "invoicing",
        key: "invoicing",
        path: PRIVATE_ROUTES.INVOICING,
      },
      {
        menuTitle: "invoices",
        key: "invoices",
        path: PRIVATE_ROUTES.INVOICES,
      },
      {
        menuTitle: "credit-notes",
        key: "credit-notes",
        resource: "credit notes",
        path: PRIVATE_ROUTES.CREDIT_NOTES,
      },
      {
        menuTitle: "expenses",
        key: "expenses",
        path: PRIVATE_ROUTES.EXPENSES,
      },
    ],
    operations: [
      {
        menuTitle: "orders",
        key: "orders",
        path: PRIVATE_ROUTES.ORDERS,
      },
      {
        menuTitle: "dispatch",
        key: "dispatch",
        path: PRIVATE_ROUTES.MOVING_DESPATCH,
      },
      {
        menuTitle: "bookings",
        key: "bookings",
        path: PRIVATE_ROUTES.BOOKINGS,
      },
      {
        menuTitle: "shipments",
        key: "shipments",
        resource: "shipments",
        path: PRIVATE_ROUTES.SHIPMENTS,
      },
      {
        menuTitle: "claims",
        key: "claims",
        path: PRIVATE_ROUTES.CLAIMS,
      },
    ],
    warehousing: [
      {
        menuTitle: "storageBoxesAndUnits",
        key: "Storage Box And Unit",
        resource: "storage box and unit",
        path: PRIVATE_ROUTES.STORAGE_BOXES_UNITS,
      },
      {
        menuTitle: "movement",
        key: "movement",
        path: PRIVATE_ROUTES.MOVEMENT,
      },
      {
        menuTitle: "transshipment",
        key: "transshipment",
        resource: "transshipment",
        path: PRIVATE_ROUTES.TRANSSHIPMENTS,
      },
      {
        menuTitle: "storageAccounts",
        key: "storageAccounts",
        resource: "storage account",
        path: PRIVATE_ROUTES.STORAGE_ACCOUNTS,
      },
    ],
    reports: [
      {
        menuTitle: "reports",
        key: "analytics",
        path: PRIVATE_ROUTES.ANALYTICS,
      },
    ],
    settings: [
      {
        menuTitle: "settings",
        key: "settings",
        path: PRIVATE_ROUTES.SETTINGS,
      },
    ],
  },
  ST: {
    dashboard: [
      {
        menuTitle: "dashboard",
        key: "overview",
        path: PRIVATE_ROUTES.OVERVIEW,
      },
    ],
    shipments: [
      {
        menuTitle: "shipments",
        key: "shipments",
        path: PRIVATE_ROUTES.SHIPMENTS_TRACKING,
      },
    ],
    settings: [
      {
        menuTitle: "settings",
        key: "settings",
        path: PRIVATE_ROUTES.SETTINGS,
      },
    ],
  },
  SPP: {
    orders: [
      {
        menuTitle: "orders",
        key: "orders",
        path: PRIVATE_ROUTES.ORDERS,
      },
    ],
    bookings: [
      {
        menuTitle: "Bookings",
        key: "bookings",
        path: PRIVATE_ROUTES.BOOKINGS,
      },
    ],
    shipments: [
      {
        menuTitle: "shipments",
        key: "shipments",
        path: PRIVATE_ROUTES.SHIPMENTS,
      },
    ],
    settings: [
      {
        menuTitle: "settings",
        key: "settings",
        path: PRIVATE_ROUTES.SETTINGS,
      },
    ],
  },
  MA: {
    operations: [
      {
        menuTitle: "orders",
        key: "orders",
        path: PRIVATE_ROUTES.ORDERS,
      },
    ],
  },
};
